<template>
  <g>
    <polygon
      class="topPolygon"
      :points="topPolygon"
    />
    <polygon
      class="rightPolygon"
      :points="rightPolygon"
    />
    <rect
      class="frontRect"
      :x="x"
      :y="y"
      :width="width"
      :height="height"
    />
  </g>
</template>

<script>
	export default {
		name: 'Shelf',
		props: {
			x: Number,
			y: Number,
			width: Number,
			height: {
				type: Number,
				default: 5,
			},
			depthOffset: Object,
		},
		computed: {
			topPolygon() {
				return `${this.x},${this.y}
						${this.x + this.width},${this.y}
						${this.x + this.width + this.depthOffset.x},${this.y - this.depthOffset.y}
						${this.x + this.depthOffset.x},${this.y - this.depthOffset.y}`;
			},
			rightPolygon() {
				return `${this.x + this.width},${this.y}
						${this.x + this.width + this.depthOffset.x},${this.y - this.depthOffset.y}
						${this.x + this.width + this.depthOffset.x},${this.y - this.depthOffset.y + this.height}
						${this.x + this.width},${this.y + this.height}`;
			},
		},
	};
</script>

<style>
	.topPolygon {
		fill: #eaeaea;
	}
	.rightPolygon {
		fill: #c4c6c8;
	}
	.frontRect {
		fill:#dcddde;
	}
</style>
